import React from "react";
import styles from "./style.module.css";
import logo from "../../../assets/img/motion_new_logo.png";
import { useLocation } from "react-router-dom";
import { linkReplaceFn } from "../../../utils/custom_funtions";

const extractOptions = (htmlString) => {
  if (!htmlString) return [];
  return htmlString.split("@@@").map((html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent.trim(); // Extract text content from HTML
  });
};

const TopicwiseQuestionRender = () => {
  const location = useLocation();
  const responseData = location.state?.responseData || [];
  const language = location.state?.language || "english";
  const module = location.state?.module || "";
  
  // Check if we need to display in two columns
  const showTwoColumns = language === "english" && module === "bulkques";

  console.log("Received Response Data:", responseData);

  // If showing two columns, split the questions into left and right arrays
  const renderQuestions = () => {
    if (!showTwoColumns) {
      // Original single column layout
      return responseData.map((question, index) => (
        <div key={index} style={{ marginTop: "1.5rem" }}>
          <div style={{ pageBreakInside: "avoid" }}>
            <div className="row mb-2">
              <div className="col-1">{index + 1}.</div>
              <div className="col-3">
                <b>Qid:</b> {question.qid}
              </div>
              <div className="col-4">
                <b>Topic:</b> {question.topic_name}
              </div>
              <div className="col-4">
                <b>Sub-Topic:</b> {question.sub_topic_name}
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-1"></div>
              <div className="col-3">
                <b>Toughness:</b> {question.toughness}
              </div>
              <div className="col-7">
                <b>Question-type:</b> {question.type}
              </div>
            </div>
            <div className="row">
              <div className="col-1"></div>
              <div className="col-11">
                <div className="row">
                  <div className="col-1">
                    <b>Ques:-</b>
                  </div>
                  {language === "both" ? (
                    <div className="col-6">
                      <p dangerouslySetInnerHTML={{ __html: linkReplaceFn(question.cq_text) }} />
                    </div>
                  ) : (
                    <div className="col-11">
                      <p dangerouslySetInnerHTML={{
                        __html: linkReplaceFn(language === "english" ? question.cq_text : question.q_text_hindi),
                      }} />
                    </div>
                  )}
                  {language === "both" && (
                    <div className="col-5">
                      <p dangerouslySetInnerHTML={{ __html: linkReplaceFn(question.q_text_hindi) }} />
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-11">
                    <ol type="A" className="row">
                    {language === "both" ? (
                    <>
                      <div className="col-5">
                        <ol type="A" style={{ margin: "10px 20px" }}>
                          {extractOptions(question.eng_option).map(
                            (option, idx) => (
                              <li key={idx}>{option}</li>
                            )
                          )}
                        </ol>
                      </div>
                      <div className="col-5">
                        <ol type="A" style={{ margin: "10px 20px 10px 170px" }}>
                          {extractOptions(question.hindi_option).map(
                            (option, idx) => (
                              <li key={idx}>{option}</li>
                            )
                          )}
                        </ol>
                      </div>
                    </>
                  ) : (
                    <div className="col-11">
                      <ol
                        type={language === "english" ? "A" : "अ"}
                        style={{ margin: "10px 20px" }}
                      >
                        {extractOptions(
                          language === "english"
                            ? question.eng_option
                            : question.hindi_option
                        ).map((option, idx) => (
                          <li key={idx}>{option}</li>
                        ))}
                      </ol>
                    </div>
                  )}
                    </ol>
                  </div>
                </div>
                <div className="row">
                  <div className="col-1">
                    <b>Answer:</b>
                  </div>
                  <div className="col-11">{question.answer}</div>
                </div>
                <div className="row">
                  <div className="col-1">
                    <b>Sol.</b>
                  </div>
                  {language === "both" ? (
                    <div className="col-6">
                      <p dangerouslySetInnerHTML={{ __html: linkReplaceFn(question.solution) }} />
                    </div>
                  ) : (
                    <div className="col-11">
                      <p dangerouslySetInnerHTML={{
                        __html: linkReplaceFn(language === "english" ? question.solution : question.solution_hin),
                      }} />
                    </div>
                  )}
                  {language === "both" && (
                    <div className="col-5">
                      <p dangerouslySetInnerHTML={{ __html: linkReplaceFn(question.solution_hin) }} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      // Two-column layout (even/odd questions)
      const leftColumnQuestions = [];
      const rightColumnQuestions = [];
      
      // Split questions into left and right arrays
      responseData.forEach((question, index) => {
        if (index % 2 === 0) {
          leftColumnQuestions.push({ question, index });
        } else {
          rightColumnQuestions.push({ question, index });
        }
      });
      
      // Render a question for the two-column layout
      const renderQuestion = ({ question, index }) => (
        <div key={index} style={{ marginTop: "1.5rem" }}>
          <div style={{ pageBreakInside: "avoid" }}>
            <div className="row mb-2">
              <div className="col-2">{index + 1}.</div>
              <div className="col-10">
                <b>Qid:</b> {question.qid}
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-2"></div>
              <div className="col-10">
                <b>Topic:</b> {question.topic_name}
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-2"></div>
              <div className="col-10">
                <b>Toughness:</b> {question.toughness}
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-2"></div>
              <div className="col-10">
                <b>Question-type:</b> {question.type}
              </div>
            </div>
            <div className="row">
              <div className="col-2"></div>
              <div className="col-10">
                <div className="row">
                  <div className="col-2">
                    <b>Ques:-</b>
                  </div>
                  <div className="col-10">
                    <p dangerouslySetInnerHTML={{
                      __html: linkReplaceFn(question.cq_text),
                    }} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-2"></div>
                  <div className="col-10">
                    <ol type="A" style={{ margin: "10px 20px" }}>
                      {extractOptions(question.eng_option).map(
                        (option, idx) => (
                          <li key={idx}>{option}</li>
                        )
                      )}
                    </ol>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2">
                    <b>Answer:</b>
                  </div>
                  <div className="col-10">{question.answer}</div>
                </div>
                <div className="row">
                  <div className="col-2">
                    <b>Sol.</b>
                  </div>
                  <div className="col-10">
                    <p dangerouslySetInnerHTML={{
                      __html: linkReplaceFn(question.solution),
                    }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      
      // Return side-by-side columns with questions
      return (
        <div className="row">
          <div className="col-6">
            {leftColumnQuestions.map(renderQuestion)}
          </div>
          <div className="col-6">
            {rightColumnQuestions.map(renderQuestion)}
          </div>
        </div>
      );
    }
  };

  return (
    <div className={`${styles.container} container-fluid printable`}>
      <div className={styles.logoSection}>
        <img src={logo} alt="Motion" />
      </div>
      <h5 className={styles.title}>
        <b>Sample Question</b>
      </h5>
      <h4 className={styles.subName}>
        <b>{responseData.length > 0 ? responseData[0].sub_name : ""}</b>
      </h4>
      <hr />

      {responseData.length > 0 ? (
        renderQuestions()
      ) : (
        <p>No questions available.</p>
      )}
    </div>
  );
};

export default TopicwiseQuestionRender;